import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./../WebsiteDeploymentServicesMerge/WebdevelopementMerge.css";
import Navbarsynergtech from "../../Homepage/Navbarsynergtech/Navbarsynergtech";
import Footer from "../../Homepage/Footer/Footer";
import FooterAll from "../../Homepage/FooterAll/FooterAll";
import Appointment from "../../Homepage/Appointment/Appointment";
import WebSolution from "../WebSolution/WebSolution";

import Banner1 from "../../Homepage/Banner1/Banner1";
import BringIdeas from "../../PortfolioPage/BringIdeas/BringIdeas";
import RelatedServices from "../../RelatedServices/RelatedServices";

function WebsiteDeploymentServicesMerge() {
  const [isVisible, setIsVisible] = useState(false);
  const appointmentRef = useRef(null);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    scrollToTop();
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top-button">
          <span>↑</span>
        </button>
      )}
      <Navbarsynergtech scrollToAppointment={scrollToAppointment} />
      <div className="main_div_webnavbar">
        <h1 className="Heading_web_navbar" style={{ marginTop: 0, marginBottom: "1rem" }}>Custom Software Development Services</h1>
        <div className="d-flex justify-content-center">
          <p className="para_web_navbar_white">Home</p>
          <p className="para_web_navbar_white">
            <MdOutlineKeyboardArrowRight />
          </p>
          <Link to="/services" className="para_web_navbar_white">Services</Link>
          <p className="para_web_navbar_white">
            <MdOutlineKeyboardArrowRight />
          </p>
          <p className="para_web_navbar_orange">Custom Software Development</p>
        </div>
      </div>
      <WebSolution scrollToAppointment={scrollToAppointment} />
    
      <RelatedServices current="custom-software-development" />
      <BringIdeas scrollToAppointment={scrollToAppointment} />
      <Banner1 />
      <div ref={appointmentRef}>
        <Appointment />
      </div>
      <FooterAll />
      <Footer />
    </div>
  );
}

export default WebsiteDeploymentServicesMerge;